import { clearAlertMessage, showAlertMessage } from "../../redux/reducer/alert-message.reducer";
import { store } from "../../redux/store";
import { AlertMessages } from "../../enums/alert-messages.enum";

export const showLoadingAlertMessage = (message?: string) => {
    store.dispatch(clearAlertMessage());
    store.dispatch(showAlertMessage({
        alertMessageType: 'loading',
        alertMessageText: message ?? AlertMessages.RequestInProgress
    }));
};